// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","login__register-password-link":"login_login__register-password-link__J7WVR","login__forgot-password-link":"login_login__forgot-password-link__ObfQp"};